import * as React from 'react';
import isNil from 'lodash/isNil';
import snakeCase from 'lodash/snakeCase';

import Banner from 'components/banners/banner/Banner';
import StatusLabel from 'components/status-label/StatusLabel';

import { __t, applyTranslations } from 'utils/language';

import './profile-banner.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./profile-banner.i18n.json'));

import type { InfluencerProfileAnchor } from 'types';

interface Props {
  anchors: Array<InfluencerProfileAnchor>,
  includesFashionIdentity: boolean,
  includesSelfIdentity: boolean
}

const COMMON_MSG_KEY = 'collabary_common';
const MSG_KEY = 'profile_banner';

const ProfileBanner: React.FC<Props> = ({
  anchors,
  includesFashionIdentity,
  includesSelfIdentity
}) => {
  const handleLinkClick = (
    event: React.SyntheticEvent<HTMLLIElement>
  ): void => {
    const target = event.currentTarget;
    const anchor = target.dataset.anchor;
    const element = document.querySelector(`#${anchor}`);

    if (isNil(element)) {
      return;
    }

    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };

  const renderTitle = (): React.ReactNode => (
    <div className="profile-banner__title">
      <div className="profile-banner__title-text">
        {__t(`${MSG_KEY}.title`)}
      </div>
      <div className="profile-banner__title-marker">
        <StatusLabel
          label={(__t(`${COMMON_MSG_KEY}.basics.new`) || '').toUpperCase()}
          layout="marker"
        />
      </div>
    </div>
  );

  const renderLink = (
    anchor: InfluencerProfileAnchor
  ): React.ReactNode => {
    const showFashionLink = anchor === 'profile-fashion-identity' && !includesFashionIdentity;
    const showSelfLink = anchor === 'profile-self-identity' && !includesSelfIdentity;

    if (!showFashionLink && !showSelfLink) {
      return null;
    }

    return (
      <li
        key={`profile-banner__link--${anchor}`}
        className="profile-banner__link"
        data-anchor={anchor}
        onClick={handleLinkClick}
      >
        <span>
          {__t(`${MSG_KEY}.links.${snakeCase(anchor)}`)}
        </span>
      </li>
    );
  };

  return (
    <div className="profile-banner">
      <Banner
        background="on-grey"
        withBorder
      >
        {renderTitle()}
        <div className="profile-banner__description">
          {__t(`${MSG_KEY}.description`)}
        </div>
        <ul className="profile-banner__links">
          {anchors.map(renderLink)}
        </ul>
      </Banner>
    </div>
  );
};

export default ProfileBanner;
